import { useQueryClient } from "@tanstack/react-query";
import { useMemo, useState } from "react";

import {
  collectCasinoGameNamesFromQueryCache,
  useResolveCasinoGameLabels,
} from "./casinoGameLabels";

/** Resolve display names for casino game ids whose bet payload arrived
 *  without a `game_name` (FE-2284). Seeds from catalogue pages already in
 *  the query cache, then backfills the rest from the Game Pass admin
 *  casino-games endpoints. Returns an id → name map that grows as lookups
 *  complete; unresolved ids are simply absent. */
export const useCasinoGameNameLabels = (
  gameIds: readonly string[],
): Readonly<Record<string, string>> => {
  const queryClient = useQueryClient();
  const [resolvedLabels, setResolvedLabels] = useState<
    Readonly<Record<string, string>>
  >({});

  const labels = useMemo(
    () =>
      collectCasinoGameNamesFromQueryCache(
        queryClient,
        gameIds,
        resolvedLabels,
      ),
    [gameIds, queryClient, resolvedLabels],
  );

  useResolveCasinoGameLabels(gameIds, labels, setResolvedLabels);

  return labels;
};
